module.exports = __webpack_public_path__ + "img/icon-component-label_Doctors.a5b6e58e.svg";